import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ConfirmPopUpFinzyFlexSkeletonData } from "../../confirm-pop-up-finzy-flex/skeleton/confirm-pop-up-finzy-flex-skeleton.component";

@Component({
    selector: 'app-skelton-confirmation-popup-with-svg',
    styleUrls: ['./skelton-confirmation-popup-with-svg.component.css'],
    templateUrl: './skelton-confirmation-popup-with-svg.component.html'
})
export class SkeltonConfirmationPopupWithSvgComponent<T> {
    constructor(
        public dialogRef: MatDialogRef<T>,
        @Inject(MAT_DIALOG_DATA) public readonly popUpData: ConfirmPopUpFinzyFlexSkeletonData,
    ) {}

    decline(): void {
        this.dialogRef.close();
    }
}